import React, { useMemo, useState, useEffect, useContext, useCallback } from "react";
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import DataTable from "../../common/DataTable";
import { GET_CUSTOMER_PRODUCT_MONTHLY_INVOICE, } from "../../../services/apiRoutes";
import { AuthContext } from "../../../context/AuthContext";
import CustomLoader from "../../common/CustomLoader";
import CustomReport from "../../common/CustomReport";
import { genericPost } from "../../../services/authServices";
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded, } from "@mui/icons-material";
import CustomDataTable from "../../common/CustomDataTable";
import CustomFilter from "../../common/CustomFilter";
import { Box, Grid } from "@mui/material";
import CustomTextField from "../../common/CustomTextField";
import CustomButton from "../../common/CustomButton";

const CustomerProductMonthlyInvoice = () => {
    const { clientCompanyId, monthDate } = useParams();
    const companyDateFormat = useCompanyDateFormat();
    const { t, i18n } = useTranslation();
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [totalGrandQty, setGrandQty] = useState("");
    const [clientCompanyName, setClientCompanyName] = useState("");
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    // ✅ Pagination states
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [filterPayload, setFilterPayload] = useState({
        shipmentId: '',
    });
    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    // const handleClearFilters = useMemo(() => {
    //     return () => {
    //         setFilterPayload({
    //             shipmentId: '',
    //         });
    //         fetchData(0, pageSize, clientCompanyId, '');
    //     };
    // }, [pageSize, clientCompanyId]);

    // ✅ FIX: clear filters resets pagination and reloads page 1 safely
    const handleClearFilters = useCallback(() => {
        setFilterPayload({ shipmentId: "" });
        setPage(0);
    }, []);




    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            { accessorKey: 'date', header: 'Date', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'shipmentId', header: 'Shipment ID', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'commercialInvoiceNo', header: 'Commercial Invoice', size: 50, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: 'customerName', header: 'Customer Name', size: 50, tableHeader: {
                    justifyContent: 'flex-start',
                },

            },
            {
                accessorKey: 'country', header: 'Country', size: 50, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: 'productName', header: 'product Name', size: 50, tableHeader: {
                    justifyContent: 'flex-start',
                }, footer: 'Total',
            },
            { accessorKey: 'totalQty', header: 'Qty', size: 50, tableStyle: { textAlign: "center" }, footerCellStyle: { textAlign: "center" }, footer: totalGrandQty, },
            {
                accessorKey: 'totalAmount', header: 'Amount', size: 50, tableStyle: { textAlign: "center" },
            },
        ],
        [totalGrandQty]);


    // const fetchData = async (pageIndex = 0, pageSize = 10, clientCompanyIdParam = clientCompanyId) => {
    //     setLoading(true);
    //     try {
    //         const payload = {
    //             page: pageIndex + 1,
    //             limit: pageSize,
    //             customerNamesId: clientCompanyIdParam,
    //             monthDate: monthDate,
    //             shipmentId: filterPayload.shipmentId || null,
    //         };

    //         const response = await genericPost(GET_CUSTOMER_PRODUCT_MONTHLY_INVOICE, payload);
    //         const invoiceList = response.data.commercialInvExps || [];
    //         let totalQty = 0;
    //         const mapped = invoiceList.map((item, idx) => {
    //             const rowQty = item.particulars?.reduce((sum, p) => sum + parseFloat(p.qty || 0), 0) || 0;
    //             const totalAmount = item.particulars?.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0) || 0;
    //             totalQty += rowQty;

    //             return {
    //                 index: idx + 1,
    //                 date: companyDateFormat(item?.date) || '',
    //                 shipmentId: item.exportShipmentList?.shipmentId || '',
    //                 commercialInvoiceNo: item.commercialInvoiceNo,
    //                 customerName: item.customer?.clientCompanyName || '',
    //                 country: item.customer?.mailingCountry?.name || '',
    //                 totalAmount: `${item?.currency?.currency_symbol || ''} ${totalAmount.toFixed(2)}`,
    //                 productName: item.particulars?.[0]?.products?.productName || '',
    //                 totalQty: `${rowQty.toFixed(2) || ""} ${item.particulars?.[0]?.productsUnit?.unitName || ''}`,
    //             };
    //         });
    //         setData(mapped);
    //         setGrandQty(totalQty.toFixed(2));
    //         setClientCompanyName(response.data.clientCompany?.clientCompanyName || "Customer Product Monthly");
    //         setRowCount(response.data.pagination?.totalRecords || 0);

    //     } catch (err) {
    //         console.error("Fetch Error:", err);
    //         setError(err.message);
    //         setData([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const fetchData = useCallback(
        async (pageIndex = page, pageLimit = pageSize) => {
            // ✅ Prevent sending invalid limit/page
            if (!pageLimit || pageLimit <= 0) pageLimit = 10;
            if (!pageIndex || pageIndex < 0) pageIndex = 0;

            setLoading(true);
            try {
                const payload = {
                    page: pageIndex + 1, // backend 1-based
                    limit: pageLimit,
                    customerNamesId: clientCompanyId,
                    monthDate: monthDate,
                    shipmentId: filterPayload.shipmentId || null,
                };

                const response = await genericPost(
                    GET_CUSTOMER_PRODUCT_MONTHLY_INVOICE,
                    payload
                );

                const invoiceList = response.data?.commercialInvExps || [];
                let totalQty = 0;

                const mapped = invoiceList.map((item, idx) => {
                    const rowQty =
                        item.particulars?.reduce(
                            (sum, p) => sum + parseFloat(p.qty || 0),
                            0
                        ) || 0;
                    const totalAmount =
                        item.particulars?.reduce(
                            (sum, p) => sum + parseFloat(p.amount || 0),
                            0
                        ) || 0;
                    totalQty += rowQty;

                    return {
                        index: idx + 1,
                        date: companyDateFormat(item?.date) || "",
                        shipmentId: item.exportShipmentList?.shipmentId || "",
                        commercialInvoiceNo: item.commercialInvoiceNo,
                        customerName: item.customer?.clientCompanyName || "",
                        country: item.customer?.mailingCountry?.name || "",
                        productName: item.particulars?.[0]?.products?.productName || "",
                        totalQty: `${rowQty.toFixed(2)} ${item.particulars?.[0]?.productsUnit?.unitName || ""
                            }`,
                        totalAmount: `${item?.currency?.currency_symbol || ""} ${totalAmount.toFixed(2)}`,
                    };
                });

                setData(mapped);
                setClientCompanyName(
                    response.data?.clientCompany?.clientCompanyName ||
                    "Customer Product Monthly"
                );
                setRowCount(response.data?.pagination?.totalRecords || 0);
                setGrandQty(response.data?.totalGrandQty?.toFixed(2) || "0.00");

            } catch (err) {
                console.error("Fetch Error:", err);
                setError(err.message);
                setData([]);
            } finally {
                setLoading(false);
            }
        },
        [clientCompanyId, monthDate, filterPayload, companyDateFormat]
    );


    // useEffect(() => {
    //     if (!clientCompanyId) return;
    //     setLoading(true);
    //     fetchData(clientCompanyId, page, pageSize,);
    // }, [clientCompanyId, page, pageSize, token, filterPayload.shipmentId]);

    // ✅ FIX: useEffect triggers only when valid pagination/filter changes
    useEffect(() => {
        if (!clientCompanyId) return;
        fetchData(page, pageSize);
    }, [clientCompanyId, page, pageSize, token, filterPayload.shipmentId]);


    const defaultView = 'customerproduct';

    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={clientCompanyName}
                columns={columns}
                data={data}
                handleFilterButton={filterOpen}
                fiterButtonTitile="Fiter"
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
            />
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <>
                        <Box>
                            <Grid container spacing={1} sx={{ padding: 0, }}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        type="text"
                                        placeholder="Enter Shipment ID"
                                        value={filterPayload.shipmentId}
                                        onChange={(e) => handleFilterChange('shipmentId', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                    <CustomButton
                                        startIcon={<FindReplaceOutlinedIcon />}
                                        title="Apply"
                                        size="small"
                                        variant="contained"
                                        onClick={fetchData}
                                    />
                                    <CustomButton
                                        variant="outlined"
                                        title="Clear"
                                        startIcon={<ClearRounded />}
                                        onClick={handleClearFilters}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
            />
        </>
    );


    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={mainContent} />
        </>
    );
};

export default CustomerProductMonthlyInvoice;
